import { dmyToYmd, ymdToDmy } from './reportDateParams'
import type { MessageLogsListPatch } from '../types/utils'
import { MESSAGE_LOGS_SESSION_KEY } from '../constants/sessionKeys'

export { MESSAGE_LOGS_SESSION_KEY }

export function readMessageLogsSession(): Record<string, unknown> | null {
  try {
    const raw = sessionStorage.getItem(MESSAGE_LOGS_SESSION_KEY)
    if (!raw) return null
    const value = JSON.parse(raw) as unknown
    return value && typeof value === 'object' && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null
  } catch {
    return null
  }
}

export function writeMessageLogsSession(data: Record<string, unknown>): void {
  sessionStorage.setItem(MESSAGE_LOGS_SESSION_KEY, JSON.stringify(data))
}

export function clearMessageLogsSession(): void {
  sessionStorage.removeItem(MESSAGE_LOGS_SESSION_KEY)
}

function normalizeDate(value: unknown): string {
  if (value == null) return ''
  const s = String(value).trim()
  if (!s) return ''
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  return dmyToYmd(s) || s
}

export function sessionFilterToMessageLogsPatch(
  session: Record<string, unknown>,
): MessageLogsListPatch {
  const patch: MessageLogsListPatch = {}
  if (typeof session.page === 'number' && session.page > 0) patch.page = session.page
  if (typeof session.perPage === 'number' && session.perPage > 0) patch.perPage = session.perPage
  if (session.sortBy === 'asc' || session.sortBy === 'desc') patch.sortBy = session.sortBy
  if (typeof session.orderBy === 'string' && session.orderBy.trim()) patch.orderBy = session.orderBy
  if (typeof session.q === 'string') patch.q = session.q
  if (typeof session.delivered === 'string') patch.delivered = session.delivered
  const fromDt = normalizeDate(session.fromDt)
  const toDt = normalizeDate(session.toDt)
  if (fromDt) patch.fromDt = fromDt
  if (toDt) patch.toDt = toDt
  return patch
}

export function buildMessageLogsSessionFromParams(p: {
  page: number
  perPage: number
  sortBy: string
  orderBy: string
  q: string
  delivered: string
  fromDt: string
  toDt: string
}): Record<string, unknown> {
  const out: Record<string, unknown> = {
    page: p.page,
    perPage: p.perPage,
    sortBy: p.sortBy,
    orderBy: p.orderBy,
    q: p.q,
  }
  if (p.delivered) out.delivered = p.delivered
  const fromDt = ymdToDmy(p.fromDt)
  const toDt = ymdToDmy(p.toDt)
  if (fromDt) out.fromDt = fromDt
  if (toDt) out.toDt = toDt
  return out
}
